/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PatientsListAliases {
  DATE_FIELD_BIRTH = 'date-field-birth',
  DATE_FIELD_EXAM_AVAILABILITY = 'date-field-exam-availability',
  DATE_FIELD_FINAL = 'date-field-final',
  DATE_FIELD_INITIAL = 'date-field-initial',
  DECK_0 = 'deck-0',
  FIELD_DATE = 'field-date',
  FIELD_DATE_FINAL = 'field-date-final',
  FIELD_DATE_INITIAL = 'field-date-initial',
  FIELD_EXAM_AVAILABILITY = 'field-exam-availability',
  FIELD_NAME_PATIENT = 'field-name-patient',
  FILTER_FIELD_RECENT_PATIENTS = 'filter-field-recent-patients',
  FILTER_PATIENTS = 'filter-patients',
  FILTERED_LIST = 'filtered-list',
  INPUT_PATIENTS_NAME = 'input-patients-name',
  MAIN_CONTEXTUAL_BAR = 'main-contextual-bar',
  MAIN_LAYOUT = 'main-layout',
  MAPPER_ENCOUNTER_TYPE = 'mapper-encounter-type',
  PANEL_0 = 'panel-0',
  PATIENT_CARD_0 = 'patient-card-0',
  PATIENT_FETCH = 'patient-fetch',
  RADIO_GROUP_RECENT_PATIENTS = 'radio-group-recent-patients',
  TEXT_ENCOUNTER_TYPE = 'text-encounter-type',
}
export { PatientsListAliases };
